import React from "react";
// material
import { styled } from "@mui/material/styles";
import {
  Box,
  TableRow,
  Skeleton,
  TableCell,
  Typography,
  Stack,
  IconButton,
  Avatar,
  Tooltip,
} from "@mui/material";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { useNavigate } from "react-router-dom";
import { fDateShort } from "src/utils/formatTime";
import { enUS } from "date-fns/locale";
import { ApiUrl } from "src/services/apiUrls";
import { useTheme } from "@mui/styles";
import Label from "src/components/label";

const ThumbImgStyle = styled("img")(({ theme }) => ({
  width: 50,
  height: 50,
  minWidth: 50,
  objectFit: "cover",
  background: theme.palette.background.default,
  marginRight: theme.spacing(2),
  border: "1px solid " + theme.palette.divider,
  borderRadius: theme.shape.borderRadiusSm,
}));

const getSafeDate = (date) => {
  const parsedDate = new Date(date);
  return date && !Number.isNaN(parsedDate.getTime())
    ? fDateShort(parsedDate, enUS)
    : "-";
};

const getImageUrl = (image) => {
  if (!image) return "";
  if (/^https?:\/\//i.test(image)) return image;
  return `${ApiUrl.IMAGE_BASE_URL}${image}`;
};

export default function BlogRow({ isLoading, row }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const rowId = row?._id || row?.id;
  return (
    <TableRow hover key={Math.random()}>
      <TableCell component="th" scope="row" padding="none">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {isLoading ? (
            <Skeleton
              variant="rectangular"
              width={50}
              height={50}
              sx={{ borderRadius: 1 }}
            />
          ) : (
            <ThumbImgStyle
              alt={row?.name}
              src={getImageUrl(row?.image)}
            />
          )}
        </Box>
      </TableCell>
      <TableCell>
        {isLoading ? <Skeleton variant="text" /> : row?.name?.slice(0, 50)}
      </TableCell>
      <TableCell align="center">
        {isLoading ? (
          <Skeleton variant="text" />
        ) : (
          <Label
            variant={theme.palette.mode === "light" ? "ghost" : "filled"}
            color={row?.is_active ? "success" : "error"}
          >
            {row?.is_active ? "active" : "in-active"}
          </Label>
        )}
      </TableCell>
      <TableCell align="right">
        {isLoading ? (
          <Skeleton variant="text" />
        ) : (
          <> {getSafeDate(row?.createdAt || row?.created_at)} </>
        )}
      </TableCell>
      <TableCell align="right">
        <Stack direction="row" justifyContent="flex-end">
          {isLoading ? (
            <>
              <Skeleton
                variant="circular"
                width={34}
                height={34}
                sx={{ mr: 1 }}
              />
              <Skeleton variant="circular" width={34} height={34} />
            </>
          ) : (
            <>
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => rowId && navigate(`/blog/blogs_events/${rowId}`)}
                  disabled={!rowId}
                >
                  <EditRoundedIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Stack>
      </TableCell>
    </TableRow>
  );
}
